var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: { "form-group": true, "form-group-lg": _vm.lg } }, [
    _c(
      "label",
      {
        class: {
          "col-xs-12": !_vm.block,
          "col-md-3": !_vm.block,
          "control-label": _vm.block,
        },
      },
      [_vm._v(_vm._s(_vm.$t("search.parallel.alignBy")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn-group clearfix",
        class: { "col-xs-12": !_vm.block, "col-md-9": !_vm.block },
        staticStyle: { display: "block" },
      },
      _vm._l(_vm.alignByOptions, function (option) {
        return _c(
          "button",
          {
            key: option.value,
            class: [
              "btn",
              _vm.alignBy === option.value
                ? "active btn-primary"
                : "btn-default",
            ],
            attrs: {
              type: "button",
              value: option.value,
              title: option.title || option.value,
            },
            on: {
              click: function ($event) {
                _vm.alignBy = option.value
              },
            },
          },
          [_vm._v(_vm._s(option.label || option.value || "document"))]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }